export const isfnr = (knr) => {
    const r = /^[0-5][0-9]$/;
    return r.test(knr !== null && knr !== void 0 ? knr : '');
};
export const isknr = (knr) => {
    const r = /^[0-5]\d{3}$/;
    return r.test(knr !== null && knr !== void 0 ? knr : '');
};
export const isyear = (year) => {
    const r = /^[12][90][0-9]{2}$/; // Any year between 1900 - 2099
    return r.test(year !== null && year !== void 0 ? year : '');
};
export const issector = (sector) => {
    const r = /^[a-zøæå]{2,3}$/;
    return r.test(sector !== null && sector !== void 0 ? sector : '');
};
